import React from "react";

export const ExpectationsSection = () => {
  return (
    <div className="w-full py-20 bg-white">
      <div className="w-full flex justify-center items-start px-[60px]">
        <div className="w-full flex flex-col md:flex-row justify-start items-start gap-4 max-w-[1292px]">
        <div className="w-full md:w-[350px] text-black text-[40px] [font-family:'Inter-Bold',Helvetica] font-bold leading-tight">
          As your trusted partner, you can expect:
        </div>
        <div className="w-full md:max-w-[942px]">
          <div className="mb-4">
            <span className="text-black text-base sm:text-lg md:text-2xl [font-family:'Inter-SemiBold',Helvetica] font-semibold">Founders First. </span>
            <span className="text-black text-base sm:text-lg md:text-2xl [font-family:'Inter-Light',Helvetica] font-light">Your success is our only metric.</span>
          </div>
          
          <div className="mb-4">
            <span className="text-black text-base sm:text-lg md:text-2xl [font-family:'Inter-SemiBold',Helvetica] font-semibold">You Are Our Only Customer. </span>
            <span className="text-black text-base sm:text-lg md:text-2xl [font-family:'Inter-Light',Helvetica] font-light">Unlike traditional VC's, whose primary focus is their LP's, our sole priority is you.</span>
          </div>
          
          <div className="mb-4">
            <span className="text-black text-base sm:text-lg md:text-2xl [font-family:'Inter-SemiBold',Helvetica] font-semibold">We Are Long-Term Co-Entrepreneurs. </span>
            <span className="text-black text-base sm:text-lg md:text-2xl [font-family:'Inter-Light',Helvetica] font-light">We commit to the entire journey — from idea to lasting impact.</span>
          </div>
          
          <div className="mb-4">
            <span className="text-black text-base sm:text-lg md:text-2xl [font-family:'Inter-SemiBold',Helvetica] font-semibold">No Playbooks. </span>
            <span className="text-black text-base sm:text-lg md:text-2xl [font-family:'Inter-Light',Helvetica] font-light">We invest where the mission matters most — and don't limit ourselves by stage, sector, or geography.</span>
          </div>
          
          <div className="mb-4">
            <span className="text-black text-base sm:text-lg md:text-2xl [font-family:'Inter-SemiBold',Helvetica] font-semibold">Early Belief. </span>
            <span className="text-black text-base sm:text-lg md:text-2xl [font-family:'Inter-Light',Helvetica] font-light">We often partner at the idea stage — when others can't yet see the potential.</span>
          </div>
          
          <div className="mb-4">
            <span className="text-black text-base sm:text-lg md:text-2xl [font-family:'Inter-SemiBold',Helvetica] font-semibold">Enduring Impact. </span>
            <span className="text-black text-base sm:text-lg md:text-2xl [font-family:'Inter-Light',Helvetica] font-light">We're not chasing quick exits; we help build companies that last — and legacies that matter.</span>
          </div>
          
          <div className="mb-4">
            <span className="text-black text-base sm:text-lg md:text-2xl [font-family:'Inter-SemiBold',Helvetica] font-semibold">How We Build Matters. </span>
            <span className="text-black text-base sm:text-lg md:text-2xl [font-family:'Inter-Light',Helvetica] font-light">We care not only about what we help build but how we build it.</span>
          </div>
          
          <div className="mb-4">
            <span className="text-black text-base sm:text-lg md:text-2xl [font-family:'Inter-SemiBold',Helvetica] font-semibold">Trust Above All. </span>
            <span className="text-black text-base sm:text-lg md:text-2xl [font-family:'Inter-Light',Helvetica] font-light">Openness, integrity, and transparency guide every step of our partnership.</span>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};